/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const CloseLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="close-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1194.0233333333333 1113.8966666666668L760.1266666666667 680L1194.023333333333 246.1033333333335L1113.8966666666665 165.9766666666667L680 599.8733333333333L246.1033333333333 165.9766666666669L165.9766666666667 246.1033333333335L599.8733333333333 680L165.9766666666667 1113.8966666666668L246.1033333333333 1193.9666666666667L680 760.1266666666667L1113.8966666666665 1194.0233333333333L1194.0233333333333 1113.8966666666668z" : "M955.2186666666668 891.1173333333334L608.1013333333334 544L955.2186666666666 196.8826666666666L891.1173333333332 132.7813333333332L544 479.8986666666666L196.8826666666667 132.7813333333334L132.7813333333334 196.8826666666668L479.8986666666667 544L132.7813333333333 891.1173333333334L196.8826666666667 955.1733333333332L544 608.1013333333333L891.1173333333334 955.2186666666666L955.2186666666668 891.1173333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
CloseLg.displayName = `Blueprint5.Icon.CloseLg`;
export default CloseLg;
